export default __webpack_public_path__ + "static/media/blog-active.2a811ab8.svg";